import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';
import { companyInfo } from '../data/mock';

export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navigation = [
    { name: 'Accueil', path: '/' },
    { name: 'Services', path: '/services' },
    { name: 'À Propos', path: '/about' },
    { name: 'Réalisations', path: '/gallery' },
    { name: 'Contact', path: '/contact' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="header-fixed">
      <div className="header-container">
        <div className="header-content">
          {/* Logo */}
          <Link to="/" className="logo-link">
            <img 
              src={companyInfo.logo} 
              alt={companyInfo.name}
              className="logo-image"
            />
            <span className="logo-text">{companyInfo.name}</span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="nav-desktop">
            {navigation.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`nav-link ${isActive(item.path) ? 'nav-link-active' : ''}`}
              >
                {item.name}
              </Link>
            ))}
          </nav>

          {/* Contact Button */}
          <a href={`tel:${companyInfo.phone.replace(/\s/g, '')}`} className="btn-contact-desktop">
            <Phone className="w-4 h-4" />
            {companyInfo.phone}
          </a>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="mobile-menu-btn"
            aria-label="Toggle menu"
          >
            {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="mobile-menu">
            <nav className="mobile-nav">
              {navigation.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={() => setIsMenuOpen(false)}
                  className={`mobile-nav-link ${isActive(item.path) ? 'mobile-nav-link-active' : ''}`}
                >
                  {item.name}
                </Link>
              ))}
            </nav>
            <a 
              href={`tel:${companyInfo.phone.replace(/\s/g, '')}`}
              className="btn-contact-mobile"
            >
              <Phone className="w-4 h-4" />
              {companyInfo.phone}
            </a>
          </div>
        )}
      </div>
    </header>
  );
};
